import React from 'react';

import { TextLink } from '@vds/buttons';

import { importantInfoLabels } from './labels';

const BroadbandInfoLink = () => (
  <TextLink
    type="standAlone"
    role="button"
    data-testid="text_Link"
    size="small"
    onClick={(e) => {
      e.preventDefault();
      window.open(importantInfoLabels.ibiUrl, '_blank');
    }}
    onKeyDown={(e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.open(importantInfoLabels.ibiUrl, '_blank');
      }
    }}
  >
    {importantInfoLabels.ibiLinkText}
  </TextLink>
);

export default BroadbandInfoLink;
